import { memo, FC, ChangeEvent } from 'react'
import { Box, Flex, useCheckbox, UseCheckboxProps } from '@chakra-ui/react'
import { Star } from 'components/icons'

type Props = {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  checked: boolean
}

const CustomStarCheckbox: FC<Props> = ({ onChange, checked }) => {
  const CustomCheckbox = (props: UseCheckboxProps) => {
    const { state, getCheckboxProps, getInputProps, htmlProps } =
      useCheckbox(props)

    return (
      <Box
        as="label"
        display="flex"
        flexDirection="row"
        alignItems="center"
        cursor="pointer"
        {...htmlProps}
      >
        <input {...getInputProps()} hidden />
        <Flex
          alignItems="center"
          justifyContent="center"
          w={6}
          h={6}
          {...getCheckboxProps()}
        >
          {state.isChecked ? (
            <Star
              boxSize="8"
              color="yellow.500"
              variant="filled"
              transition="all 0.2s"
            />
          ) : (
            <Star
              boxSize="8"
              color="gray.300"
              variant="filled"
              transition="all 0.2s"
            />
          )}
        </Flex>
      </Box>
    )
  }

  return <CustomCheckbox onChange={onChange} isChecked={checked} />
}

export default memo(CustomStarCheckbox)

/* 

Example:


<Controller
    name="checkbox"
    control={control}
    render={({ field: { onChange, value } }) => <CustomCheckboxStar onChange={onChange} checked={value} />}
/>


*/
